const lightboxInitialState = {
  loop: false,

  arrowColor:           '#b6b6b6',
  autoPlay:             false,
  backgroundColor:      '#fff',
  border:               0,
  closeBackground:      '#161617',
  closeColor:           '#d2d2d2',
  gallItems:            false,
  infinigall:           false,
  htmlClose:            `&times;`,
  htmlNext:             `<span>Next</span>`,
  htmlPrev:             `<span>Prev</span>`,
  numeration:           false,
  numerationBackground: '#161617',
  numerationColor:      '#d2d2d2',
  numerationPosition:   'top', // top || bottom
  overlayClose:         true,
  overlayColor:         'rgba(0, 0, 0, 0.5)',
  preloaderColor:       '#fff',
  titleAttr:            'title',
  titleBackground:      '#161617',
  titleColor:           '#d2d2d2',
  titlePosition:        'top', // top || bottom

  open:    false,
  slides:  [],
  current: null,
  loading: true,
};

export default lightboxInitialState;